
/*------------------------
トップページ
-------------------------*/
(function($) {
  $(function(){
    //日付スクロールタブのcurrentが画面上に表示されるように対応
    var $parents = $(".dateLists-wrapper");
    if($(".dateLists-wrapper .dateLists").length > 0){
      var $current = $(".dateLists-wrapper .dateLists .current");
      $parents.scrollLeft($current.offset().left - ($parents.width() - 20));
    }

    $(".swiper-wrapper .prevBtn").on("click",function(){
      $left = $parents.scrollLeft();
      console.log($left);
      $position = $left - $parents.width();
      $parents.animate({
        scrollLeft:$position
      });

      //ボタンの有効制御
      if($position < 0){
        $(".swiper-wrapper .prevBtn").addClass("hide");
      }
      if($(".swiper-wrapper .nextBtn").hasClass("hide")){
        $(".swiper-wrapper .nextBtn").removeClass("hide");
      }
    });

    $(".swiper-wrapper .nextBtn").on("click",function(){
      $left = $parents.scrollLeft();
      $position = $left + $parents.width();
      $parents.animate({
        scrollLeft:$position
      });
      //ボタンの有効制御
      if(($position + $parents.width()) > $parents[0].scrollWidth){
        $(".swiper-wrapper .nextBtn").addClass("hide");
      }
      if($(".swiper-wrapper .prevBtn").hasClass("hide")){
        $(".swiper-wrapper .prevBtn").removeClass("hide");
      }
    });
  });


  //左カラム記事制御
  var dfpRequestflg = false;
  $(window).on("resize scroll",function(){

    var winW = $(window).width();
    var winH = $(window).height();
    var scrollY = $(window).scrollTop();
    var $parents = $(".pageMain-inner");
    var $fixedContents = $(".pageMain-inner .fixedContents");
    var $innerContents = $fixedContents.children(".innerContents");
    var diff = 70;
    var $adSize;

    if($innerContents.length > 0){
      //サイドが300px以上あった場合
      if(winW > 1366 && scrollY > 300){
        $innerContents.addClass("active");
        if(winW > 1666 && !$innerContents.hasClass("large")){
          $innerContents.addClass("large");
          diff = 190;
        }else if(winW <= 1666 && $innerContents.hasClass("large")){
          $innerContents.removeClass("large");
        }
      }else{
        $innerContents.removeClass("active");
      }

      //固定処理
      if((scrollY + winH) >= ($parents.offset().top + $parents.height()) - diff){
        $fixedContents.removeClass("is-fixed").css('top',$parents.height() - $innerContents.height() - diff);
      }else{
        $fixedContents.addClass("is-fixed").css('top','');
      }
    }else if(winW > 1366 && scrollY > 300 && !dfpRequestflg){
      if(winW>1666){
        $('.wrapper').css('min-width','1666px');
        $adSize=[[1, 1], [300, 250], [300, 600]];
      }
      else{
        $('.wrapper').css('min-width','1366px');
        $adSize=[[1, 1], [160, 600]];
      }
      dfpRequestflg = Boolean("true");
      $('.pageFooter').css('z-index','0');
      moreAd('leftAd',$adSize);
    }
  });

})(window.jQuery);

/*------------------------
テキスト速報
-------------------------*/
(function($) {
  $(window).on('load',function(){
    //TODO 必要であれば初回読み込み処理

    //手動更新
    $(".js-reload-btn").on("click", function() {
      //TODO 更新処理

      var $btn = $(this);
      $btn.addClass('is-animating');
    });
    $(".js-reload-btn").on('animationend', function() {
      $(this).removeClass('is-animating');
    });

    //60秒更新
    var reloadTime = 60 * 1000;//自動更新間隔
    var timer = undefined;//自動更新タイマー
    $('#live-reload').on("change", function(e) {
      if (e.currentTarget.checked) {
        timer = setInterval(function(){
          //TODO　更新処理
        }, reloadTime);
      }
      else {
        clearInterval(timer);
        timer = undefined;
      }
    });

  });
})(window.jQuery);

//GoogleDFP

var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

var adslot0;
googletag.cmd.push(function() {
googletag.pubads().enableSingleRequest();
googletag.enableServices();
});
// スロットの固有名を生成する関数
// 追加するdivのidをadslot1からカウントアップさせる
var nextSlotId = 0;
function generateNextSlotName() {
var id = nextSlotId++;
return 'adslot' + id;
}
// moreAdを実行させるたびにDFPにリクエストを送り
// 引数のIDにappendする。
function moreAd(adTarget,adSize) {
  // 次のスロット名を生成
	var slotName = generateNextSlotName();
  // スロット用の div を作成
	var slotDiv = document.createElement('div');
	slotDiv.style.cssText = "text-align:center;";
  // 引数のIDを取得
	var slotNode = document.getElementById(adTarget);
	slotDiv.id = slotName;  // ID は slotName と同じである必要があります。
	slotNode.appendChild(slotDiv);
  // スロット自体を定義。div の登録には display()、
  // 広告の取得には refresh() を呼び出します。
	googletag.cmd.push(function() {
		var slot = googletag.defineSlot('/21662775423/dspc/special/rectangle', adSize , slotName).
    setTargeting("test","infinitescroll").
    addService(googletag.pubads());
    // スロットの div がページに配置された後 refresh の呼び出しより前に
    // display を呼び出す必要があります。
    googletag.display(slotName);
    googletag.pubads().refresh([slot]);
  });
}
